import React from 'react';

import moment from 'moment';

import TextButton from 'CommonComponents/TextButton';

import EditIcon from 'Assets/icons/edit.svg';
import XMarkIcon from 'Assets/icons/xmark.svg';

/**
 * Whether a requisition is still open, and whether an approver sent it back.
 *
 * Exported beside the row rather than written out by each list. Both gate the
 * row's own Edit and Cancel buttons, and a second copy in Home's unified list
 * would be a copy that a later edit to this one does not reach.
 */
export const isPurchaseRequisitionPending = (row, pendingStatus) => row.status === pendingStatus;

export const isPurchaseRequisitionRejected = (row, rejectedStatus) => row.status === rejectedStatus;

/**
 * One purchase requisition a user raised.
 *
 * The actions in particular — which decide when a requisition may be edited or
 * cancelled — must not exist in two places, so any list of a user's own
 * requisitions renders this row rather than restating those rules.
 *
 * `typeLabel` and `showValue` are OPTIONAL and ADDITIVE: Home's unified My
 * Requests list names the type in a column of its own and carries a Value
 * column, and passes both. The guards keep the row renderable as its four
 * base columns.
 */
export default function UserRequestListPurchaseRequisitionsRow({ row, typeLabel, showValue, rowClassName, isPending, isRejected, onView, onEdit, onCancel }) {
    return (
        <tr className={rowClassName}>
            <td className="tw-cursor-pointer inbud-date-cell" onClick={onView}>
                {moment(row.created_at).format('DD-MM-YYYY')}
            </td>
            {!!typeLabel && (
                <td className="tw-cursor-pointer" onClick={onView}>
                    {typeLabel}
                </td>
            )}
            <td className="tw-cursor-pointer" onClick={onView}>
                {row.title}
            </td>
            {!!showValue && (
                <td className="tw-cursor-pointer inbud-numeric-cell" onClick={onView}>
                    {row.estimated_value}
                </td>
            )}
            <td className="tw-cursor-pointer" onClick={onView}>
                {row.canceled_at ? $t('Canceled') : row.status}
            </td>
            <td>
                <div className="tw-flex tw-items-center tw-gap-x-3">
                    {(isRejected(row) || !!row.canceled_at) && (
                        <TextButton variant="primary" onClick={() => onEdit(row)}>
                            <EditIcon className="tw-w-3 tw-h-3" /> {$t('Edit')}
                        </TextButton>
                    )}
                    {isPending(row) && !row.canceled_at && (
                        <TextButton variant="danger" onClick={() => onCancel(row)}>
                            <XMarkIcon className="tw-w-3 tw-h-3" />
                            {$t('Cancel')}
                        </TextButton>
                    )}
                </div>
            </td>
        </tr>
    );
}
